<script context="module">
    export const name = "small view";
</script>

<script lang="ts">
    import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
    import { stripTags } from "@reperio-news/core.components/includes/Helpers";
    import { z } from "zod";
    import { getContext } from "svelte";
    type Data = z.infer<typeof Data>;
    import ImageView from "@reperio-news/core.components/ImageView.svelte";
    import { slugToColor } from "../TopMenu/View.svelte";

    const context: SvelteStore<any> = getContext("context");
    const c = getContext("parentBlockColumnCount");

    let categoryColor = "red";

    $: if (data && data.content) {
        categoryColor = slugToColor(
            data.content.category?.slug,
            $context.global_blocks?.TopMenu_main_menu?.data?.items
        );
    }

    export let data: Data;
</script>

{#if data && data.content}
    <div class="item co-{$c}">
        <div class="main">
            {#if data.content.poster}
                <a class="image" href={data.content.url}>
                    <ImageView
                        src={data.content.poster}
                        crop={data.content.poster.crop}
                        width={340}
                        height={204}
                        fit="cover"
                    />
                </a>
            {/if}
            <a
                class="title"
                href={data.content.url}
                title={stripTags(data.content.summary)}
                >{@html stripTags(data.content.title, ["i", "b", "strong", "font"])}</a
            >
        </div>

        {#if data.content.category}
            <div class="other">
                <a
                    style="color: {categoryColor}"
                    href="//{data.content.domain}/{data.content.category.slug}"
                    class="category">{data.content.category.name}</a
                >
            </div>
        {/if}
    </div>
{/if}

<style lang="scss">
    div.co-1 {
        width: calc(100% - 10px);
        justify-content: space-between;
        align-items: center;
        display: flex;
        flex-direction: column;

        .main {
            .image {
                width: 170px;
                aspect-ratio: 5 / 3;
                height: auto;
                overflow: hidden;
                margin-right: 10px;
            }
        }

        .other {
            width: calc(100% - 10px);
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
        }
    }

    .item:hover {
        opacity: 0.9;
    }

    .item {
        width: 315px;
        margin-bottom: 10px;
        margin-right: 5px;
        overflow: hidden;
        padding: 5px;

        color: #000;
        padding-bottom: 5px;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        position: relative;
        background-color: #fff;

        .main {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .image {
                width: 150px;
                /* box ratio matches the requested image ratio — no second
                   crop from object-fit on top of the server-side one */
                aspect-ratio: 5 / 3;
                overflow: hidden;
                margin-right: 10px;
            }

            a.title {
                width: calc(100% - 80px);
                // height: 70px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                text-overflow: hidden;
                white-space: normal;
                text-overflow: ellipsis;
                font-family: "Source Sans Pro", sans-serif;
                font-style: normal;
                letter-spacing: 0.25px;
                font-weight: 600;
                font-size: 0.9rem;
            }
        }

        .other {
            .category {
                font-family: "PT Sans Narrow", sans-serif;
                font-size: 0.9rem;
                font-weight: bold;
            }
        }
    }

    :global {
        .carousel-news {
            div.item {
                min-width: calc((var(--parent-width) / 4) - 15px);
            }
        }
    }

    @media only screen and (max-width: 1024px) {
        .item {
            height: auto;
            width: 300px;
        }
    }

    @media only screen and (max-width: 1000px) {
        .co-1 {
            width: calc(50% - 20px);
        }

        :global {
            .carousel-news {
                div.item {
                    min-width: calc(
                        (var(--parent-width) / 3) - 15px
                    ) !important;
                }
            }
        }
    }

    @media only screen and (max-width: 750px) {
        :global {
            .carousel-news {
                div.item {
                    min-width: calc(
                        (var(--parent-width) / 2) - 15px
                    ) !important;
                }
            }
        }
    }

    @media only screen and (max-width: 650px) {
        .co-1 {
            width: auto;
            min-width: 350px;
        }

        :global {
            .carousel-news {
                div.item {
                    min-width: calc(var(--parent-width) - 15px) !important;
                }
            }
        }
    }

    @media only screen and (max-width: 980px) {
        .item {
            width: calc(50% - 30px);
            min-width: 300px;

            .main {
                display: flex;
                justify-content: center;
                align-items: center;

                a.title {
                    height: auto !important;
                    max-height: 105px !important;
                    font-size: 1em !important;
                    -webkit-line-clamp: 4;
                }
            }
        }
    }

    @media only screen and (max-width: 750px) {
        .item {
            width: calc(100% - 10px);

            a.title {
                height: 125px;
                width: calc(100% - 125px);
                justify-content: flex-start;
            }
        }
    }
</style>
